import { useTranslation } from "../../../../customHooks/useTranslation/index.js";
import { Button } from "waapi/waap-ui/components/Button/Button.js";
import { RefreshArrow01Linear } from "waapi/waap-ui/components/Iconsax/RefreshArrow01Linear.js";
import { ICONSAX_SIZE } from "waapi/waap-ui/components/Iconsax/Iconsax.types.js";
import { Text } from "waapi/waap-ui/components/Text/Text.js";
import { TextSize, TextWeight } from "waapi/waap-ui/components/Text/Text.types.js";
import { Container } from "./style.js";
import { LargeAskWaalaxyAccountProps } from "./types.js";

export const LargeAskWaalaxyAccount = ({ onClick }: LargeAskWaalaxyAccountProps): JSX.Element => {
    const { t, translations } = useTranslation();

    return (
        <Container>
            <RefreshArrow01Linear size={ICONSAX_SIZE.LARGE} />
            <Text align="center" size={TextSize["X-SMALL"]} weight={TextWeight.BOLD}>
                {t(translations.waalaxy.link_account.title())}
            </Text>
            <Button width="100%" onClick={onClick}>
                {t(translations.waalaxy.link_account.button())}
            </Button>
        </Container>
    );
};
